/**
 * Strips HTML tags to show plain text preview (last_body may contain rich text HTML)
 * This is purely for display purposes and should not be used for any other purpose.
 * It is not a replacement for DOMPurify sanitization (see RichTextComposer and MessageContent).
 */
export default function stripHtmlTags(html) {
  if (!html) return '';

  const strip = (s) => s
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"');

  // List preview: show the first item with its bullet/number + an ellipsis, not all items run together.
  const listMatch = html.match(/<(ul|ol)[^>]*>\s*<li[^>]*>([\s\S]*?)<\/li>/i);
  if (listMatch) {
    const lead = strip(html.slice(0, listMatch.index)).trim();
    const marker = listMatch[1].toLowerCase() === 'ol' ? '1.' : '•';
    return `${lead ? `${lead} ` : ''}${marker} ${strip(listMatch[2]).trim()}...`;
  }

  // Multi-line preview: split on \n + <br>/block boundaries, show the first line + an ellipsis.
  const lines = html
    .split(/\n|<br\s*\/?>|<\/?(?:p|div|h[1-6]|li|tr|blockquote)(?:\s[^>]*)?>/i)
    .map((line) => strip(line).replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  if (lines.length > 1) {
    return `${lines[0]}...`;
  }
  return lines[0] || '';
}
